import { render, staticRenderFns } from "./Shippings.vue?vue&type=template&id=650f86d4&scoped=true&"
import script from "./Shippings.vue?vue&type=script&lang=js&"
export * from "./Shippings.vue?vue&type=script&lang=js&"
import style0 from "./Shippings.vue?vue&type=style&index=0&id=650f86d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f86d4",
  null
  
)

export default component.exports